import i18next from 'i18next';
import {useSyncExternalStore} from 'react';

import {getLanguage} from './i18n';

function subscribe(onChange: () => void) {
  i18next.on('languageChanged', onChange);

  return () => {
    i18next.off('languageChanged', onChange);
  };
}

function getLanguageSnapshot() {
  return getLanguage();
}

export function useLanguage() {
  return useSyncExternalStore(
    subscribe,
    getLanguageSnapshot,
    getLanguageSnapshot
  );
}
